
/// <amd-module name="TFS/Admin/Common/Constants/CustomErrorConstants" />
export namespace CustomErrorSearchString {
    export const CollectionAlreadyLinked = "already linked";
    export const UnexpectedJsonToken = "Unexpected token";
    export const JsonParseError = "JSON.parse";
    export const CollectionNotLinked = "not yet linked";
    export const IdentityMaterializationFailure = "VS403283:";
    export const UserNeedsSignIn = "TF401444:";
    export const UserNotAuthorized = "TF400813:";
    export const NetworkConnectionError = "TF400893:";
    export const MicrosoftEmailAddress = "VS850039:";
    export const MoreThanOneCollection = "VS850043:";
    export const ExistingMembership = "active or inactive memberships";
    export const NodeDuplicateName = "VS402371";
    export const AadAccessSilentException = "AadAccessSilentException";
    export const AcyclicMember = "TF50233";
}
